import { useEffect, useState } from "react";

export type Route =
  | { page: "clients" }
  | { page: "new-client" }
  | { page: "edit-client"; organisationId: string }
  | { page: "onboarding"; organisationId: string; auditEngagementId?:string }
  | { page: "overview"; organisationId: string }
  | { page: "evidence"; organisationId: string }
  | { page: "actions"; organisationId?: string }
  | { page: "history"; organisationId: string }
  | { page: "next" }
  | { page: "reports" }
  | { page: "report"; reportId: string; resumeLast?: boolean; sectionId?:string; area?: "evidence"|"assessment"|"client" }
  | { page: "report-preview"; reportId: string; versionId: string }
  | { page: "client-preview"; reportId:string; versionId:string; sectionId?:string }
  | { page: "client-report"; versionId: string; sectionId?: string };

export function clientPortalPreviewPath(reportId:string,versionId:string,sectionId?:string){
  const base=`/reports/${encodeURIComponent(reportId)}/client-preview/${encodeURIComponent(versionId)}`;
  return sectionId?`${base}/${encodeURIComponent(sectionId)}`:base;
}

export function parseRoute(pathname = `${window.location.pathname}${window.location.search}`): Route {
  const [cleanPath,query=""] = pathname.split("?");
  const parts = cleanPath.split("/").filter(Boolean);
  if (!parts.length || parts[0] === "clients" && parts.length === 1) return { page: "clients" };
  if (parts[0] === "clients" && parts[1] === "new") return { page: "new-client" };
  if (parts[0] === "clients" && parts[1] && parts[2] === "edit") return { page: "edit-client", organisationId: parts[1] };
  if (parts[0] === "clients" && parts[1] && parts[2] === "audits" && parts[3] && parts[4] === "onboarding") return { page: "onboarding", organisationId: parts[1], auditEngagementId:parts[3] };
  if (parts[0] === "clients" && parts[1] && parts[2] === "onboarding") return { page: "onboarding", organisationId: parts[1] };
  if (parts[0] === "clients" && parts[1] && parts[2] === "evidence") return { page: "evidence", organisationId: parts[1] };
  if (parts[0] === "clients" && parts[1] && parts[2] === "actions") return { page: "actions", organisationId: parts[1] };
  if (parts[0] === "clients" && parts[1] && parts[2] === "history") return { page: "history", organisationId: parts[1] };
  if (parts[0] === "clients" && parts[1]) return { page: "overview", organisationId: parts[1] };
  if (parts[0] === "actions") return { page: "actions" };
  if (parts[0] === "whats-next") return { page: "next" };
  if (parts[0] === "reports" && parts[1] && parts[2] === "client-preview" && parts[3]) return { page:"client-preview",reportId:parts[1],versionId:parts[3],sectionId:parts[4] };
  if (parts[0] === "reports" && parts[1] && parts[2] === "preview" && parts[3]) return { page: "report-preview", reportId: parts[1], versionId: parts[3] };
  if (parts[0] === "reports" && parts[1]) {
    const parameters=new URLSearchParams(query),area=parameters.get("area");
    return { page: "report", reportId: parts[1], resumeLast: parameters.get("resume") === "1", sectionId:parameters.get("section")??undefined, area:area==="assessment"||area==="client"||area==="evidence"?area:undefined };
  }
  if (parts[0] === "reports") return { page: "reports" };
  if (parts[0] === "client" && parts[1] === "reports" && parts[2]) return { page: "client-report", versionId: parts[2], sectionId: parts[3] };
  return { page: "clients" };
}

export function useRoute() {
  const [route, setRoute] = useState<Route>(() => parseRoute());
  useEffect(() => {
    const listener = () => setRoute(parseRoute());
    window.addEventListener("popstate", listener);
    return () => window.removeEventListener("popstate", listener);
  }, []);
  function navigate(path: string) {
    window.history.pushState(null, "", path);
    setRoute(parseRoute(path));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  return { route, navigate };
}
